export const imageIds = [
  'avocado',
  'samples',
  'book',
  'minerals',
  'pills',
  'fish',
  'cigarette',
  'coffee',
  'woman',
  'cooking',
  'doctor-ipad',
  'group-beach',
  'group-hiking',
  'woman-explains',
  'woman-laptop',
];

export const infoImageIds = ['risk factors', 'survival rate', 'attitude', 'genetics', 'sex', 'age'];

export const getInterstitialImageId = (id: string, type: 'info' | 'regular' = 'regular'): string => {
  if (type === 'info') {
    if (infoImageIds.includes(id)) return id;
    return 'risk factors';
  }

  if (imageIds.includes(id)) return id;
  return 'pills';
};
